import {Injectable} from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import {Observable} from "rxjs/Observable";
import {environment} from "../environments/environment";
import {SpinnerService} from "./service/spinner.service";
import {tap} from "rxjs/operators";

@Injectable()
export class Interceptor implements HttpInterceptor {

  constructor(private spinnerService: SpinnerService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (request.url != null && (request.url.startsWith("https://") || request.url.startsWith("http://"))) {
      return next.handle(request);
    }

    const customReq = request.clone({
          headers: request.headers.set('Access-Control-Allow-Origin', '*'),
          url: environment.apiUrl2 + `${request.url}`,
          withCredentials: true
        }
    );
    let displayLoadingAnimation = request.headers.has("showing-spinner");
    if (!displayLoadingAnimation) {
      this.spinnerService.requestStarted();
    }
    return this.handler(next, customReq, displayLoadingAnimation);
  }

  handler(next, customReq, displayLoadingAnimation) {
    return next.handle(customReq)
        .pipe(
            tap(
                (event) => {
                  if (event instanceof HttpResponse && !displayLoadingAnimation) {
                    this.spinnerService.requestEnded();
                  }
                },
                (error: HttpErrorResponse) => {
                  this.spinnerService.resetSpinner();
                  if (error.status === 401) {
                    localStorage.clear(); //removes the token from the store as we expect that the token is invalid
                    window.location.reload();
                  }
                  throw error;
                }
            ),
        );
  }


}
